import type { SvgComponent } from '@/types/SvgComponent';

export const FigmaLogo: SvgComponent = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2689_424)">
        <path
          d="M3.72852 16.6666C3.72852 14.8256 5.22589 13.3333 7.073 13.3333H10.4175V16.6666C10.4175 18.5075 8.9201 19.9999 7.073 19.9999C5.22589 19.9999 3.72852 18.5075 3.72852 16.6666Z"
          fill="#24CB71"
        />
        <path
          d="M10.417 -6.10352e-05V6.66661H13.7615C15.6086 6.66661 17.106 5.17422 17.106 3.33327C17.106 1.49232 15.6086 -6.10352e-05 13.7615 -6.10352e-05L10.417 -6.10352e-05Z"
          fill="#FF7237"
        />
        <ellipse cx="13.7332" cy="10" rx="3.34448" ry="3.33333" fill="#00B6FF" />
        <path
          d="M3.72852 3.33335C3.72852 5.1743 5.22589 6.66669 7.073 6.66669L10.4175 6.66669V1.95503e-05L7.073 1.95503e-05C5.22589 1.95503e-05 3.72852 1.4924 3.72852 3.33335Z"
          fill="#FF3737"
        />
        <path
          d="M3.72852 9.99992C3.72852 11.8409 5.22589 13.3333 7.073 13.3333H10.4175V6.66658L7.073 6.66658C5.22589 6.66658 3.72852 8.15897 3.72852 9.99992Z"
          fill="#874FFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2689_424">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
